export const plantTree = {
  id: "site-torino", type: "site", name: "Salumificio Piemonte", status: "live", children: [
    { id: "dept-production", type: "department", name: "Produzione", status: "live", children: [
      { id: "mixer-01", type: "machine", name: "Impastatrice sottovuoto MZ-500", status: "live", children: [
        { id: "mixing-bowl", type: "component", name: "Vasca di miscelazione", status: "live" },
        { id: "vacuum-unit", type: "component", name: "Gruppo del vuoto", status: "live" },
        { id: "mixer-control", type: "component", name: "Quadro di controllo", status: "live" },
      ] },
    ] },
    { id: "dept-packaging", type: "department", name: "Confezionamento", status: "live", children: [
      { id: "thermoformer-01", type: "machine", name: "Termoformatrice TF-300", status: "warning", children: [
        { id: "forming-station", type: "component", name: "Stazione di formatura", status: "live" },
        { id: "sealing-station", type: "component", name: "Stazione di saldatura", status: "warning" },
        { id: "labeler", type: "component", name: "Etichettatrice automatica", status: "live" },
      ] },
    ] },
    { id: "dept-cold-storage", type: "department", name: "Magazzino freddo", status: "live", children: [
      { id: "refrigeration-01", type: "machine", name: "Unità frigorifera CF-02", status: "live", children: [
        { id: "compressor", type: "component", name: "Compressore frigorifero", status: "live" },
        { id: "evaporator", type: "component", name: "Evaporatore", status: "live" },
        { id: "cold-probe", type: "component", name: "Sonda temperatura cella", status: "live" },
      ] },
    ] },
  ],
};

export const defaultTwinConfig = {
  protocol: "OPC UA",
  endpoint: "opc.tcp://10.20.1.15:4840",
  sync: true,
  signals: [
    { name: "temperatura impasto", source: "ns=2;s=Mixer.ProductTemp", unit: "°C", frequency: "1 Hz" },
    { name: "vuoto camera", source: "ns=2;s=Mixer.Vacuum", unit: "mbar", frequency: "2 Hz" },
    { name: "velocità pale", source: "ns=2;s=Mixer.Speed", unit: "rpm", frequency: "10 Hz" },
  ],
};

export const initialEvents = [
  { id: 1, type: "Lotto in lavorazione", value: "SAL-2026-0904-17", time: "12:45:31", tone: "ok" },
  { id: 2, type: "Temperatura impasto", value: "3.8 °C", time: "12:44:58", tone: "ok" },
  { id: 3, type: "Sanificazione", value: "Ciclo CIP completato", time: "02 set", tone: "info" },
];

export const plants = [
  { id: "site-torino", name: "Salumificio Piemonte", city: "Torino, IT", coordinates: [7.6869, 45.0703], status: "live", assets: 14, twins: 3, alerts: 1, completeness: 64 },
  { id: "site-duesseldorf", name: "Düsseldorf Assembly", city: "Düsseldorf, DE", coordinates: [6.7735, 51.2277], status: "live", assets: 84, twins: 71, alerts: 0, completeness: 84 },
  { id: "site-zaragoza", name: "Zaragoza Logistics", city: "Zaragoza, ES", coordinates: [-0.8891, 41.6488], status: "warning", assets: 62, twins: 43, alerts: 5, completeness: 69 },
  { id: "site-brno", name: "Brno Components", city: "Brno, CZ", coordinates: [16.6068, 49.1951], status: "live", assets: 107, twins: 88, alerts: 1, completeness: 82 },
  { id: "site-gdansk", name: "Gdańsk Energy Hub", city: "Gdańsk, PL", coordinates: [18.6466, 54.352], status: "offline", assets: 31, twins: 28, alerts: 3, completeness: 90 },
];

export function indexTree(root) {
  const nodes = new Map();
  const parents = new Map();
  const visit = (node, parent = null) => {
    nodes.set(node.id, node);
    if (parent) parents.set(node.id, parent.id);
    (node.children || []).forEach((child) => visit(child, node));
  };
  visit(root);
  return { nodes, parents };
}

export function relatives(root, id) {
  const { nodes, parents } = indexTree(root);
  const node = nodes.get(id);
  const parent = nodes.get(parents.get(id));
  const siblings = parent?.children || [root];
  const position = siblings.findIndex((item) => item.id === id);
  return {
    node,
    parent,
    children: node?.children || [],
    previous: position > 0 ? siblings[position - 1] : null,
    next: position >= 0 && position < siblings.length - 1 ? siblings[position + 1] : null,
  };
}

export function breadcrumb(root, id) {
  const { nodes, parents } = indexTree(root);
  const path = [];
  let cursor = nodes.get(id);
  while (cursor) {
    path.unshift(cursor);
    cursor = nodes.get(parents.get(cursor.id));
  }
  return path;
}

export function addChildNode(root, parentId, child) {
  if (!root || !child?.id || indexTree(root).nodes.has(child.id)) return root;
  if (root.id === parentId) return { ...root, children: [...(root.children || []), child] };
  let changed = false;
  const children = (root.children || []).map((item) => {
    const next = addChildNode(item, parentId, child);
    if (next !== item) changed = true;
    return next;
  });
  return changed ? { ...root, children } : root;
}
